/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import Box from "@mui/material/Box";
import { Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import AutomationRuns from "./AutomationRuns";
import { tabbedDataGridPage } from "../../styles/commonPageStyles";

// The tab chain is stretched to the viewport so the grid inside a panel can
// claim whatever height is left below the tab list.
const fillHeight = {
  mainBox: {
    ...tabbedDataGridPage.mainBox,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  tabContainer: {
    ...tabbedDataGridPage.tabContainer,
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  tabPanel: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    // paddingLeft: "4px",
    // `display: flex` above would override the browser's [hidden] rule and
    // make the inactive panel claim flex space — keep it collapsed.
    "&[hidden]": { display: "none" },
  },
};

const Automations = () => {
  const [selectedTab, setSelectedTab] = useState("automationRuns");

  return (
    <Box sx={fillHeight.mainBox}>
      <Box sx={fillHeight.tabContainer}>
        <TabContext value={selectedTab}>
          <Box sx={tabbedDataGridPage.tabListBox}>
            <TabList
              onChange={(e, newValue) => setSelectedTab(newValue)}
              sx={tabbedDataGridPage.tabList}
            >
              <Tab
                key="main"
                label="Automation Runs"
                value="automationRuns"
                icon={<></>}
                iconPosition="end"
              />
            </TabList>
          </Box>

          <TabPanel key="main" value="automationRuns" sx={fillHeight.tabPanel}>
            <AutomationRuns />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
};

export default Automations;
